var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrders(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.71333 2.05846C9.8991 1.98048 10.1084 1.98051 10.2942 2.05857L17.5405 5.10357C17.8189 5.22054 18 5.49305 18 5.795C18 5.81319 17.9993 5.83126 17.998 5.84921C17.9993 5.86722 18 5.8854 18 5.90374V14.1977C18 14.4995 17.8192 14.7718 17.5411 14.8889L10.2948 17.9412C10.1087 18.0196 9.89885 18.0196 9.71274 17.9413L2.45911 14.889C2.18092 14.772 2 14.4996 2 14.1977V5.90374C2 5.8854 2.00066 5.86722 2.00195 5.84921C2.00066 5.83126 2 5.81319 2 5.795C2 5.49295 2.18119 5.22038 2.4597 5.10346L9.71333 2.05846ZM3.5 6.92325V13.6996L9.24637 16.1177V9.33552L3.5 6.92325ZM10.7464 9.34143V16.1233L16.5 13.6998V6.92369L10.7464 9.34143ZM15.314 5.795L10.0035 3.56346L8.28923 4.28309L13.6011 6.51477L15.314 5.795ZM11.665 7.32835L7.35195 5.51631L6.33398 5.10388L4.68764 5.795L10.0035 8.02654L11.665 7.32835ZM15.6419 9.27992C15.8026 9.66172 15.6233 10.1014 15.2415 10.2621L12.6737 11.3423C12.2919 11.5029 11.8521 11.3236 11.6915 10.9418C11.5309 10.56 11.7102 10.1203 12.092 9.95968L14.6598 8.87943C15.0416 8.71881 15.4813 8.89811 15.6419 9.27992ZM14.633 12.5061C14.7945 12.8875 14.6162 13.3276 14.2348 13.4891L13.1902 13.9314C12.8088 14.0929 12.3687 13.9146 12.2072 13.5332C12.0457 13.1517 12.224 12.7116 12.6054 12.5501L13.6499 12.1078C14.0314 11.9464 14.4715 12.1246 14.633 12.5061Z",
    fill: "#667085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrders);
export default __webpack_public_path__ + "da1f556d4d2966911b7546ef65fe8195.svg";
export { ForwardRef as ReactComponent };